
<div class="class">
    <!-- <div class="class">{{'language-selector.choose-language'|translate }}</div>
    <select (change)="selectLanguage($event)">
        <option value="es-MX">{{'language-selector.language-one'|translate}}</option>
        <option value="en-US">{{'language-selector.language-two'|translate}}</option>
        <option value="fr-FR">{{'language-selector.language-three'|translate}}</option>
    </select> -->
</div>
